module.exports = __webpack_public_path__ + "img/oura ring 4.850dcd73.jpg";